import { ClerkProvider } from "@clerk/react";
import type { ReactNode } from "react";

type AuthProviderProps = {
  children: ReactNode;
};

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

function MissingClerkKey() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-6 text-slate-100">
      <div className="w-full max-w-md rounded-lg border border-red-500/40 bg-slate-900 p-6">
        <h1 className="text-xl font-semibold">Authentication unavailable</h1>
        <p className="mt-3 text-sm text-slate-300">
          VITE_CLERK_PUBLISHABLE_KEY is required to load the auth shell.
        </p>
      </div>
    </div>
  );
}

export function AuthProvider({ children }: AuthProviderProps) {
  if (!publishableKey) {
    return <MissingClerkKey />;
  }

  return (
    <ClerkProvider
      publishableKey={publishableKey}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      afterSignOutUrl="/sign-in"
      appearance={{
        variables: {
          colorPrimary: "#4f46e5",
          colorBackground: "#ffffff",
          colorText: "#0f172a",
          borderRadius: "0.5rem",
        },
      }}
    >
      {children}
    </ClerkProvider>
  );
}
